/**
- @설명 : 환전신청정보 slice
*/

export interface excUserInfo {
    /** 통화코드
     * @type {string}
     */
    crcd?: string

    /** 거래금액
     * @type {number}
     */
    trnAmt?: number

    /** 적용환율
     * @type {number}
     */
    aplyXrt?: number

    /** 환율우대율
     * @type {number}
     */
    xrtPrnlRt?: number

    /** 출금금액
     * @type {number}
     */
    drotAmt?: number

    /** 가상계좌번호
     * @type {string}
     */
    vrtlAcn?: string

    /** 수취인한글명
     * @type {string}
     */
    drwKrnNm?: string

    /** 생년월일
     * @type {string}
     */
    birtYmd?: string

    /** 휴대폰번호
     * @type {string}
     */
    clphNo?: string

    /** 타점권1금액
     * @type {number}
     */
    obc1Amt?: number

    /** 일부대체금액
     * @type {number}
     */
    paalAmt?: number

    /** 유입경로구분코드
     * @type {string}
     */
    inflPathDcd?: string

    /** 입금시각
     * @type {string}
     */
    mnrcHms?: string
}

export const initialState: excUserInfo = {
    crcd: '',
    trnAmt: 0,
    aplyXrt: 0,
    xrtPrnlRt: 0,
    drotAmt: 0,
    vrtlAcn: '',
    drwKrnNm: '',
    obc1Amt: 0,
    paalAmt: 0,
    inflPathDcd: '',
    birtYmd: '',
    clphNo: '',
    mnrcHms: '',
}

/**
- @Rest URI : http://도메인/uib/mao/fns/frx/crd0104	
- @설명 : TODO. 테스트용 추후 삭제 예정
*/
export interface frxLocation {
    data: {
        rnn: string
        csm: string
        tlfaCmcmDcd: string
        telNo1: string
        telNo2: string
        telNo3: string
        ci: string
        wbcsRlnmAltrNo: string
        trnYmd: string
        trhsSrn: string
        usrIdntNo: string
        birthYmd: string
    }
}

/**
- @Rest URI : http://도메인/uib/mao/fns/frx/crd0104	
- @설명 : TODO. 테스트용 추후 삭제 예정
*/
export interface session_DTO {
    key: string
    data: {
        rnn: string
        csm: string
        tlfaCmcmDcd: string
        telNo1: string
        telNo2: string
        telNo3: string
        ci: string
        wbcsRlnmAltrNo: string
        trnYmd: string
        trhsSrn: string
        usrIdntNo: string
        birthYmd: string
        edpsCsn?: string
        ebkJnngYn?: string
        nofcIotaHoldYn?: string
        mngmBrcd?: string
        fntrLmacHoldYn?: string
        lmtCancType?: string
        age?: string
    }
}

export interface session_DTO2 {
    key: string
    data: {
        alplDcd: string
    }
}

export interface cache_DTO {
    key: string
    data: {
        prdCode: string
    }
}

export interface selectUserInfo_IDT {
    /** 전체상품코드(ASIS:ALL_PDCD)
     * @type {string}
     */
    allPdcd: string

    /** 계좌목록조회여부(ASIS:SEARCH_ACNT_YN)
     * @type {string}
     */
    ctoaIqyn: string
}

export interface selectUserInfo_ODT {
    /** 당행고객여부
     * @type {string}
     */
    onbnCusYn: string

    /** 휴대폰번호변경여부
     * @type {string}
     */
    cpnMdfcYn: string

    /** 고객EDD대상등록여부
     * @type {string}
     */
    cusEddTgtRgsnYn: string

    /** 전자금융가입여부
     * @type {string}
     */
    ebkJnngYn: string

    /** 주소변경여부
     * @type {string}
     */
    adrMdfcYn: string

    /** 도로명사용여부
     * @type {string}
     */
    rdnmUseYn: string

    /** 거래가능여부
     * @type {string}
     */
    trnAblYn: string

    /** 비대면입출식계좌보유여부
     * @type {string}
     */
    nofcIotaHoldYn: string

    /** 관리점부점코드
     * @type {string}
     */
    mngmBrcd: string

    /** 금융거래목적확인제외대상여부
     * @type {string}
     */
    fntrObjtCnfaEctgYn: string

    /** 금융거래한도계좌보유여부
     * @type {string}
     */
    fntrLmacHoldYn: string

    /** 금융거래목적확인대상여부결과내용
     * @type {string}
     */
    fntrObjtCnfaTgynRsltCon: string

    /** 전산고객번호
     * @type {string}
     */
    edpsCsn: string

    /** 단기다계좌개설여부
     * @type {string}
     */
    shtrMltacOpnYn: string

    /** 거래완료여부
     * @type {string}
     */
    trnFnsgYn: string

    /** 입금마감일시
     * @type {string}
     */
    mnrcClosTs: string

    /** "그룹KEY값 (전행고객실명대체번호^개인법인상세구분코드^거래년월일^거래내역일련번호)"
     * @type {string}
     */
    grpKeyVl: string

    /** 마케팅동의여부
     * @type {string}
     */
    mrknCosnYn: string

    /** 무능력자신고여부
     * @type {string}
     */
    ncpStmtYn: string

    /** 피후견인구분코드
     * @type {string}
     */
    psvtGrdnDcd: string

    /** 연령
     * @type {string}
     */
    age: string

    /** 고객전자주소
     * @type {string}
     */
    cusElcrAdr: string

    /** FATCA등록여부
     * @type {string}
     */
    fatcaRgsnYn: string

    /** 거래대상실명번호여부
     * @type {string}
     */
    trtgRnnYn: string

    /** 해외납세의무자여부
     * @type {string}
     */
    ovrsPytxObltYn: string

    /** 한도제한유형(0: 거래가능, 1:비대면최초신규여부, 2:알뜰폰이용자여부, 3:모바일인증서발급 7일이내여부, N: 조회오류)
     * @type {string}
     */
    lmtCancType: string

    /** 계좌목록
     * @type {AcntList[]}
     */
    acntList?: AcntList[]
}

/**
 * @description 계좌목록
 */
export interface AcntList {
    /** 상품코드
     * @type {string}
     */
    pdcd?: string

    /** 상품명
     * @type {string}
     */
    pdm?: string

    /** 계좌번호
     * @type {string}
     */
    acn?: string

    /** 관리부점코드
     * @type {string}
     */
    mngmBrcd?: string

    /** 계약상태코드
     * @type {string}
     */
    arrScd?: string

    /** 한도계좌여부
     * @type {string}
     */
    lmtAcntYn?: string

    /** 내부계약번호
     * @type {string}
     */
    icn?: string
}
